module.exports = __webpack_public_path__ + "img/Group-32710-1-1.54fd3a30.png";